exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabPic[data-v-0d709300]{width:40px !important;height:40px !important}.tabPic img[data-v-0d709300]{width:100%;height:100%}.productScore[data-v-0d709300]  .el-rate{line-height:2.4 !important}.pictrue[data-v-0d709300]{width:60px;height:60px;border:1px dotted rgba(0,0,0,.1);margin-right:10px;position:relative;cursor:pointer}.pictrue img[data-v-0d709300]{width:100%;height:100%}.btndel[data-v-0d709300]{position:absolute;z-index:1;width:20px !important;height:20px !important;left:46px;top:-4px}", ""]);

// exports
